
<template>
  <zj-layout-container class="user-layout" v-loading="loading" :element-loading-text="loadingText">
    <div class="zj-layout-left">
      <zj-layout-container>
        <zj-layout-main>
          <div class="zj-layout-main-content bgcolor scrollable">
            <el-form
              class="zj-search-form,faceleft"
              ref="form"
              :model="avatarobj"
              :label-width="labelWidth"
            >
              <el-row>
                <el-form-item label="搜索时间">
                  <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    unlink-panels
                    :clearable="false"
                  ></el-date-picker>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="排序方式" style="width:100%">
                  <el-select v-model="SoltKey" placeholder="请选择" style="width:100%">
                    <el-option key label="无" value></el-option>
                    <el-option
                      v-for="item in Solt"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="评分" style="width:100%">
                  <el-select v-model="scoreKey" placeholder="请选择" style="width:100%">
                    <el-option key label="全部" value></el-option>
                    <el-option
                      v-for="item in score"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row style="text-align:center">
                <el-form-item>
                  <div style="width:45rem;height:45rem;border: 1px solid gray;">
                    <el-avatar
                      v-if="avatarobj.url"
                      shape="square"
                      fit="fill"
                      :src="avatarobj.url"
                      style="width:45rem;height:45rem"
                    ></el-avatar>
                  </div>
                  <div class="UploadAuator">
                    <el-upload
                      :show-file-list="false"
                      accept="image/png, image/gif, image/jpg, image/jpeg"
                      :http-request="httpRequest"
                      :before-upload="beforeupload"
                      :on-success="uploadsuccess"
                      :on-progress="uploadProgress"
                      :on-error="uploadError"
                      :data="uploadData"
                      :file-list="fileList"
                    >
                      <div class="el-icon-upload UploadAuatorBtn">点击上传人脸</div>
                    </el-upload>
                  </div>
                </el-form-item>
              </el-row>
              <el-row style="text-align:center">
                <el-form-item label class="bottom">
                  <el-button @click="onReseat">重 置</el-button>
                  <el-button @click="onSearch">搜 索</el-button>
                  <el-button @click="onControlAvatar">布 控</el-button>
                </el-form-item>
              </el-row>
            </el-form>
          </div>
        </zj-layout-main>
        <zj-layout-footer></zj-layout-footer>
      </zj-layout-container>
    </div>
    <div class="zj-layout-right">
      <zj-layout-container>
        <zj-layout-header>
          <el-form>
            <el-form-item label class="right">
              <el-button @click="lookMap(this)" ref="mapPic">{{showmapbtnText}}</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div v-show="!showMap" class="zj-layout-main-content bgcolor scrollable">
            <div style="width:100%;height:auto">
              <div v-for="avatar in avatars" :key="avatar" class="avatar">
                <div>
                  <el-avatar shape="square" :size="120" fit="fill" :src="avatar.url"></el-avatar>
                  <div style="padding: 0.5rem;">{{avatar.cameraName}}</div>
                  <div style="padding: 0.5rem;">{{avatar.time}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="showMap" class="map"></div>
        </zj-layout-main>
        <zj-layout-footer></zj-layout-footer>
      </zj-layout-container>
    </div>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";

export default {
  name: "FaceAuatarList",
  controller: "UI",
  action: "FaceAuatarList",
  props: {
    query: { type: Object, default: null },
  },
  data() {
    return {
      date: [new Date(), new Date()],
      avatarobj: {
        url: null,
      },
      Solt: [
        { lable: "时间", value: "Time" },
        { lable: "评分", value: "score" },
      ],
      SoltKey: "",
      score: [
        { lable: "90及以上", value: 90 },
        { lable: "80及以上", value: 80 },
        { lable: "70及以上", value: 70 },
        { lable: "65及以上", value: 65 },
      ],
      scoreKey: "",
      UploadDraw: true,
      uploadData: {
        //todo
        module: "人脸模块", //模块名
        submodule: "", //子模块
        assocID: "rlmk", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      loading: false,
      loadingText: "加载中...",
      avatars: [],
      showMap: false,
      showmapbtnText: "查看轨迹",
    };
  },
  created: function () {
    if (this.query.avatarobj) {
      this.avatarobj = this.query.avatarobj;
      this.search();
    }
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    search() {
      this.avatars = [
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: "",
        },
      ];
      if (this.avatars.length > 0) {
        this.onDrawMap();
      }
    },
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    onReseat() {
      this.avatarobj.url = null;
      this.SoltKey = "";
      this.scoreKey = "";
      this.date = [new Date(), new Date()];
      this.avatars = [];
      // eslint-disable-next-line no-undef
      //$(".map").empty();
    },
    onSearch() {
      if (!this.avatarobj.url) {
        this.errmsg("查询失败，请上传照片 ");
        return;
      }
      this.search();
    },
    beforeupload: function () {
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function (response) {
      this.loading = false;
      if (response.url) {
        this.avatarobj.url = response.url;
        this.search();
      }
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    lookMap() {
      if (this.showMap) {
        this.showMap = false;
        this.showmapbtnText = "查看轨迹";
      } else {
        this.showMap = true;
        this.showmapbtnText = "查看列表";
      }
    },
    onDrawMap: function () {
      this.$nextTick(function () {
        // 创建地图，并通过样式让地图填满窗口
        let that = this;
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "FaceMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              mapStyle: "",
              togglePanelVisiable: false,
              // mapLayers: "DOM",
              // clickToShowLocation: false,
              // reportGeo: true,
              // onGotGeo: function(e) {
              //   e.handled = true;
              //   if (that.marker) {
              //     that.marker.setPosition(
              //       e.map.newPoint(e.point.lng, e.point.lat)
              //     );
              //   } else {
              //     //that.marker = that.addMarker(e.map, e.point);
              //   }
              //   that.dialogVisible2 = true;
              //   that.lat = e.point.lat;
              //   that.lng = e.point.lng;
              // },
              onMapCreated: function (e) {
                console.log("e");
                console.log(e);
                that.mapInstance = e.map;
                // e.map.clearAll();
                that.center = e.map.config.center;
                setTimeout(() => {
                  //  that.addDom();
                }, 1000);
              },
            },
          });
        });
      });
    },
    //布控
    onControlAvatar() {
       this.$router.push({
          path: "/plugin/Face/UI/FaceAddControl",
          query: { url: this.avatarobj.url, date: new Date() },
        });
    },
  },
};
</script>
<style scoped>
.faceleft .el-form-item .el-form-item__content {
  width: 100%;
}
.UploadAuator {
  width: 30rem;
  height: 5rem;
  position: relative;
  top: -5rem;
  left: 8rem;
  border-radius: 1rem;
  background-color: #386bff;
}
.UploadAuatorBtn {
  width: 30rem;
  font-size: 2rem;
  text-align: center;
  line-height: 5rem;
  height: 100%;
}
</style>